<section class="user-guide" *ngIf="data" #panelElRef>
  <top-wave *ngIf="data.waves.value[0]"></top-wave>
  <div class="user-guide__content">
    <div class="user-guide__title">
      <h1 *ngIf="data.title.value">{{ data.title.value }}</h1>
      <h2 *ngIf="data.subtitle.value">{{ data.subtitle.value }}</h2>
    </div>
    <div class="user-guide__wrapper">
      <div *ngFor="let item of items">
        <div *ngIf="item.header.value"
             class="user-guide__header"
             [innerHTML]="item.header.value | safe"></div>
        <div *ngFor="let linkItem of item.items.value">
          <div *ngIf="linkItem.subheader.value"
               class="user-guide__subheader"
               [innerHTML]="linkItem.subheader.value | safe"></div>
          <div class="user-guide__link" *ngFor="let link of linkItem.links.value">
            <app-button *ngIf="link" [data]="link"></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <bottom-wave *ngIf="data.waves.value[1]"></bottom-wave>
</section>
